import Resource from '../resource'
import request from '../../utils/request';

class Branch extends Resource {
    constructor() {
        super('branches');
    }

    sendMail(branchId,type) {
        return request({
          url: `/${this.uri}/send/mail/${branchId}/${type}`,
          method: 'get',
        //   params: {
        //     type: type
        //   },
          data: type,
        });
        
      }

    getConnections(branchId) {
        return request({
            url: `/branch-connections/${branchId}`,
            method: 'get',
        });
    }

    storeConnection(data) {
        return request({
            url: `/branch-connections`,
            method: 'post',
            data: data,
        });
    }

    updateConnection(id, data) {
        return request({
            url: `/branch-connections/${id}`,
            method: 'put',
            data: data,
        });
    }

    deleteConnection(id) {
        return request({
            url: `/branch-connections/${id}`,
            method: 'delete',
        });
    }

}

export {Branch as default};
